/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useEffect, useState, useRef } from 'react';
import {
  FieldArray,
  ArrayHelpers,
  FormikProvider,
  useFormik,
} from 'formik';
import {
  Button,
  Typography,
  Collapse,
  Row,
  Col,
  Checkbox,
} from 'antd';
import { PlusCircleOutlined, SaveOutlined, MinusCircleOutlined } from '@ant-design/icons';
import {
  Form,
  Input,
  Select,
  AutoComplete,
  DatePicker,
} from 'formik-antd';
import moment from 'moment';
// import moment, { Moment } from 'moment';
// import isEqual from 'lodash.isequal';
import classNames from 'classnames';
import debounce from 'lodash.debounce';
import * as Yup from 'yup';
// import { v4 } from 'uuid';
import isArray from 'lodash.isarray';
import { DefaultOptionType } from 'antd/lib/select';
import { useStore } from '../../../store';
import { USER_ID } from '../../../store/modules/user/user.constants';
import { ReactComponent as ThrashCan } from '../../../assets/icons/thrashCan.svg';
// import FormControl from '../../lib/form-control';
// import NewProperty from '../../lib/new-property';
import LeavePageModal from '../../lib/leave-page-modal';
import { useActions } from '../../providers/actions-provider/actions.context';
import { useLocalStorage } from '../../providers/local-storage-provider/local-storage.context';
import {
  // IFind,
  IFilter,
  ISort,
  ISortItem,
} from '../create-report/interfaces';
import { IListsForReport, IReportQuickRange } from '../../../store/modules/report/i-report';
import createMongoSort from '../../../utils/create-mongo-sort';
// import ReportSort from './components/report-sort';
import createSortSelectData from '../../../utils/create-sort-select-data';
import { IColumn } from '../../../store/modules/report/i-column';
import DeleteModal from '../../lib/delete-modal';
import '../create-zone/create-zone.less';
import checkPermission from '../../../utils/permissions';
import './report-params.less';

const { Panel } = Collapse;
const { Option } = Select;

const RANGE_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';

const REPORT_INITIAL_VALUES: IInitialValues = {
  from: '',
  to: '',
  filters: [],
  sorts: [],
  displayTimeFilter: false,
  timeFilterActive: false,
  quickRange: undefined,
};

// regex validator
export function validatePreset(preset: string | undefined, regex: string[]): boolean {
  if (!preset) return false;
  return regex.some((el) => {
    const regexObj = new RegExp(el);
    return regexObj.test(preset);
  });
}

// TODO: <remove> Remove when Asset Types menu is refactored
export function getQuickDateFromMongoString(
  object: { [key: string]: string },
  value: string | null | undefined,
): string {
  return object[value as string];
}

// constants and function for working with quick ranges presets
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function getKeyByValue(object: { [key: string]: string }, value: string | null | undefined) {
  return Object.keys(object).find((key) => object[key] === value);
}
// TODO: </remove> Remove when Asset Types menu is refactored

export function getQuickRangeByValue(
  ranges: IReportQuickRange[],
  value: string,
): IReportQuickRange | undefined {
  return ranges?.find((item) => item.value === value);
}

export function getQuickRangeByToAndFrom(
  ranges: IReportQuickRange[],
  from: string,
  to: string,
): IReportQuickRange | undefined {
  return ranges?.find((item) => item.from === from && item.to === to);
}

const isNumber = (value: string) => /^[0-9]+$/.test(value);
// eslint-disable-next-line
const isNotNullOrUndefined = (value: any) => !(value === null || value === undefined);

// eslint-disable-next-line
function validateTime(parent: any, value: string | undefined, regex: string[]) {
  if (!parent.displayTimeFilter) {
    return true;
  }

  if (!value || (value && value.trim() === '')) {
    return false;
  }

  return isNumber(value)
    || validatePreset(value, regex)
    || moment(value, RANGE_DATE_FORMAT, true).isValid();
}

const buildReportFormValidationSchema = (regex: string[]) => Yup.object().shape({
  from: Yup.string().test('test-from-field', '(not valid value)', function v(value) {
    return validateTime(this.parent, value, regex);
  }),
  to: Yup.string().test('test-to-field', '(not valid value)', function v(value) {
    return validateTime(this.parent, value, regex);
  }),
  filters: Yup.array().of(
    Yup.object().shape({
      field: Yup.string().required('(field is required)'),
      type: Yup.string().required('(type is required)'),
      value: Yup.string().required('(value is required)'),
    }),
  ),
  sorts: Yup.array().of(
    Yup.object().shape({
      sort: Yup.string(),
      active: Yup.boolean(),
    }),
  ),
});

interface IInitialValues {
  from: string;
  to: string;
  fromDate?: string;
  toDate?: string;
  filters?: IFilter[];
  sorts?: ISortItem[];
  displayTimeFilter?: boolean;
  timeFilterActive?: boolean;
  quickRange?: string;
  timeFilterServer?: boolean;
}

interface IKeyValue {
  /* eslint-disable-next-line */
  [key: string]: any;
}
/* eslint-disable */
interface IFieldArrayRefProps {
  fieldArrayHelpers: ArrayHelpers;
  values: any;
  dirty: boolean;
  children?: React.ReactNode;
}

class FieldArrayRef extends React.Component<IFieldArrayRefProps> {
  addItem(value: any) {
    const { fieldArrayHelpers: { push } } = this.props;
    push(value);
  }

  isDirty() {
    return this.props.dirty;
  }

  render() {
    return (
      <>
        {this.props.children}
      </>
    );
  }
}
/* eslint-enable */

interface IReportParamsProps extends IListsForReport {
  showCheckboxes?: boolean;
  showSave?: boolean;
  onSaveAction?: (find: string, sort: string) => void;
  submitButtonLabel: string;
  notEditable: boolean;
  submitButtonAlwaysEnabled?: boolean;
  onSubmitAction: (find: string, sort: string) => void;
  filtersString?: string;
  sortsString?: string;
  reportColumns?: IColumn[];
  reportCollection: string;
  renderAdditionalButtons?: () => JSX.Element;
  expanded?: boolean;
  id?: string;
  userFilters?: string;
  userSorts?: string;
}

const FILTERS_PANEL_KEY = '0';
const SORTS_PANEL_KEY = '1';

const ReportParams = ({
  showCheckboxes = false,
  showSave = false,
  onSaveAction,
  regex,
  quickRanges: reportQuickRanges,
  operators,
  filterFields,
  submitButtonLabel,
  submitButtonAlwaysEnabled,
  onSubmitAction,
  filtersString,
  sortsString,
  reportColumns,
  reportCollection,
  notEditable,
  renderAdditionalButtons,
  expanded = true,
  id: reportId,
  userFilters,
  userSorts,
}: IReportParamsProps): JSX.Element => {
  // to hook + memo
  const { reportActions, userActions } = useActions();
  const {
    reportFieldSuggestions,
  } = useStore();
  const localStorageService = useLocalStorage();
  const userID: number | null = localStorageService.get(USER_ID);
  const [filterSuggestions, setFilterSuggestions] = useState<DefaultOptionType[]>([]);
  const [reportInitialValues, setReportInitialValues] = useState<IInitialValues>(
    REPORT_INITIAL_VALUES,
  );
  const [expandedPanels, setExpandedPanels] = useState<string[]>(
    expanded ? [FILTERS_PANEL_KEY] : [],
  );

  const [deleteModalVisible, setDeleteModalVisible] = useState<boolean>(false);
  const [deleteTarget, setDeleteTarget] = useState<{ type: 'filter' | 'sort' | 'timeFilter'; index?: number; } | null>(null);

  const savedValuesRef = useRef<IInitialValues>({
    ...REPORT_INITIAL_VALUES,
    filters: reportInitialValues.filters || [],
    sorts: reportInitialValues.sorts || [],
  });

  const hasNotWritePermission = !checkPermission('reports', 'write');
  const showRemoveFromView = hasNotWritePermission && showCheckboxes;

  const parseFilters = ({ filtersString: filters, repValues, server }:
  { filtersString: string; repValues: IInitialValues; server?: boolean;}) => {
    const reportFilters: IFilter[] = [];
    // eslint-disable-next-line
      const findObj: any = JSON.parse(filters);
    if (findObj.$and) {
      // eslint-disable-next-line
        findObj.$and.forEach((f: any) => {
        const field = Object.keys(f)[0];
        if (field === 'time') {
          const gte = f[field].$gte;
          const lte = f[field].$lte;
          if (isNotNullOrUndefined(gte) && isNotNullOrUndefined(lte)) {
            // eslint-disable-next-line no-param-reassign
            repValues.from = validatePreset(gte, regex)
              ? gte
              : moment(gte).format(RANGE_DATE_FORMAT);
            // eslint-disable-next-line no-param-reassign
            repValues.to = validatePreset(lte, regex)
              ? lte
              : moment(lte).format(RANGE_DATE_FORMAT);
          } else {
            const type = Object.keys(f[field])[0];
            const value = f[field][type];
            reportFilters.push({
              field,
              type,
              value,
              active: true,
              server,
            });
          }
        } else {
          const type = Object.keys(f[field])[0];
          const value = f[field][type];
          reportFilters.push({
            field,
            type,
            value,
            active: true,
            server,
          });
        }
      });
    } else {
      // eslint-disable-next-line
        for (const key in findObj) {
        if (key === 'time') {
          const timeFilter = findObj[key];

          if (isNotNullOrUndefined(timeFilter.$gte) && isNotNullOrUndefined(timeFilter.$lte)) {
            // eslint-disable-next-line no-param-reassign
            repValues.from = validatePreset(timeFilter.$gte, regex)
              ? timeFilter.$gte
              : moment(timeFilter.$gte).format(RANGE_DATE_FORMAT);
            // eslint-disable-next-line no-param-reassign
            repValues.to = validatePreset(timeFilter.$lte, regex)
              ? timeFilter.$lte
              : moment(timeFilter.$lte).format(RANGE_DATE_FORMAT);
            // eslint-disable-next-line no-param-reassign
            repValues.timeFilterServer = server;
          } else {
            const filterKey = Object.keys(timeFilter)[0];
            const customTimeFilter = {
              field: 'time',
              type: `${filterKey}`,
              value: timeFilter[filterKey],
              active: true,
              server,
            };
            reportFilters.push(customTimeFilter);
          }
        } else {
          const typeAndValue = Object.entries(findObj[key]);
          const value = typeAndValue[0][1] as string;
          reportFilters.push({
            field: key,
            type: typeAndValue[0][0],
            value,
            active: true,
            server,
          });
        }
      }
    }
    return reportFilters;
  };

  const parseSorts = ({ sortsString: sorts, server }
  : { sortsString: string; server?: boolean }) => {
    const reportSorts: ISortItem[] = [];
    const parsed = JSON.parse(sorts);
    const sortKeys = Object.keys(parsed);
    if (sortKeys.length > 0) {
      sortKeys.forEach((sortKey) => {
        const direction = parsed[sortKey];
        const sortString = direction === 1
          ? createMongoSort(sortKey, 'ASC')
          : createMongoSort(sortKey, 'DESC');
        reportSorts.push({ sort: sortString, active: true, server });
      });
    }
    return reportSorts;
  };

  useEffect(() => {
    if (userID) {
      userActions.getCurrentUser(+userID);
    }
  }, []);

  useEffect(() => {
    const values = { ...REPORT_INITIAL_VALUES };
    let reportFilters: IFilter[] = [];
    if (filtersString) {
      reportFilters = [
        ...reportFilters,
        ...(parseFilters({ filtersString, repValues: values, server: hasNotWritePermission })),
      ];
    }

    if (userFilters) {
      const ownFilters = parseFilters({ filtersString: userFilters, repValues: values });
      // The user's own row wins over a report filter on the same field — otherwise the field
      // shows twice and both values get ANDed together on execute.
      const ownFields = new Set(ownFilters.map((f) => f.field.toLowerCase()));
      reportFilters = [
        ...reportFilters.filter((f) => !ownFields.has(f.field.toLowerCase())),
        ...ownFilters,
      ];
    }

    values.filters = reportFilters;

    let reportSorts: ISortItem[] = [];
    if (sortsString) {
      reportSorts = [
        ...reportSorts,
        ...(parseSorts({ sortsString, server: hasNotWritePermission })),
      ];
    }

    if (userSorts) {
      reportSorts = [
        ...reportSorts,
        ...(parseSorts({ sortsString: userSorts })),
      ];
    }

    if (reportSorts.length === 0) {
      reportSorts.push({ sort: '', active: false });
    }

    values.sorts = reportSorts;
    if (values.from !== '' && values.to !== '') {
      values.displayTimeFilter = true;
      values.timeFilterActive = true;
    }
    setReportInitialValues(values);
    savedValuesRef.current = values;
  }, [filtersString, sortsString, reportQuickRanges]);

  const defaultQuickRange = reportQuickRanges.find((item) => item.from === reportInitialValues.from
    && item.to === reportInitialValues.to)?.value;

  // TODO: this is duplicated in filter-modal.tsx, move it where it can be reusable
  const debouncedSuggestionsSearch = debounce((searchText, fieldIndex, formikFilters) => {
    const data = reportFieldSuggestions.data[formikFilters[fieldIndex].field];
    const opts = (data || []).filter(
      (suggestion: { value: string; }) => (
        suggestion.value.toLowerCase().includes(searchText.toLowerCase())),
    );
    setFilterSuggestions(opts);
  }, 500);

  const filtersRef = useRef<FieldArrayRef>(null);
  const sortsRef = useRef<FieldArrayRef>(null);

  const renderAddSortButton = (panelToExpandKey: string) => (
    <Button
      disabled={notEditable}
      type="link"
      onClick={(event) => {
        sortsRef.current?.addItem({ sort: '', active: false });
        event.stopPropagation();
        if (!expandedPanels.includes(panelToExpandKey)) {
          setExpandedPanels([...expandedPanels, panelToExpandKey]);
        }
      }}
    >
      New sort
      <PlusCircleOutlined style={{ fontSize: '20px' }} />
    </Button>
  );

  const renderFiltersExtraButtons = (
    panelToExpandKey: string,
    // eslint-disable-next-line
    values: any,
    // eslint-disable-next-line
    setFieldValue: (n: string, v: any) => void,
  ) => (
    <p>
      <Button
        disabled={notEditable}
        type="link"
        onClick={(event) => {
          event.stopPropagation();
          if (!values.displayTimeFilter) {
            setFieldValue('displayTimeFilter', true);
            setFieldValue('timeFilterActive', true);
            setFieldValue('from', '');
            setFieldValue('to', '');
            setFieldValue('fromDate', '');
            setFieldValue('toDate', '');
            setFieldValue('quickRange', '');
          }
          if (!expandedPanels.includes(panelToExpandKey)) {
            setExpandedPanels([...expandedPanels, panelToExpandKey]);
          }
        }}
      >
        New time filter
        <PlusCircleOutlined style={{ fontSize: '20px' }} />
      </Button>
      <Button
        disabled={notEditable}
        type="link"
        onClick={(event) => {
          filtersRef.current?.addItem({
            field: '',
            type: '',
            value: '',
            active: true,
          });
          event.stopPropagation();
          if (!expandedPanels.includes(panelToExpandKey)) {
            setExpandedPanels([...expandedPanels, panelToExpandKey]);
          }
        }}
      >
        New filter
        <PlusCircleOutlined style={{ fontSize: '20px' }} />
      </Button>
    </p>
  );

  /* eslint-disable-next-line */
  // console.log('RENDER REPORT PARAMS');
  /**
   * Creates a date picker handler that will update the from or to fields and updates
   * the quickRange value if needed
   */
  const onDateSelected = (
    name: string,
    setFieldValue: (n: string, v: string) => void,
  ) => (
    /* eslint-disable-next-line */
    (value: any, dateString: string) => {
      setFieldValue(name, dateString);
      if (value) {
        setFieldValue('quickRange', '');
      }
    });

  const onQuickRangeSelected = (setFieldValue: (n: string, v: string) => void) => (
    (value: string) => {
      const qr = getQuickRangeByValue(reportQuickRanges, value);
      /* eslint-disable-next-line */
      // console.log('quick range selected', qr);
      if (qr) {
        setTimeout(() => {
          setFieldValue('from', qr.from);
          setFieldValue('to', qr.to);
          setFieldValue('fromDate', '');
          setFieldValue('toDate', '');
          setFieldValue('quickRange', value);
        }, 1);
      }
    }
  );

  /* eslint-disable-next-line */
  const defineSuggestions = (values: any, filterIdx: number) => (
    (value: string) => {
      if (!value || value.trim() === '') {
        const { data } = reportFieldSuggestions;
        const fieldData = (
          data[values.filters[filterIdx].field]
        );
        setFilterSuggestions(fieldData);
      }
    }
  );

  /* eslint-disable-next-line */
  const buildReportPayload = ({ values, save }: { values: any; save: boolean }) => {
    // eslint-disable-next-line
    // console.log('submit values', values);
    // eslint-disable-next-line
    const ands: any[] = [];
    if (values.from && values.to && values.displayTimeFilter && (save || values.timeFilterActive)) {
      ands.push({
        time: {
          $gte: validatePreset(values.from, regex)
            ? `${values.from}`
            : moment(isNumber(values.from) ? parseInt(values.from, 10) : values.from).valueOf(),
          $lte: validatePreset(values.to, regex)
            ? `${values.to}`
            : moment(isNumber(values.to) ? parseInt(values.to, 10) : values.to).valueOf(),
        },
      });
    }

    if (values.filters) {
      values.filters
        .filter((f: IFilter) => save || f.active)
        .forEach(
          (f: IFilter) => {
            let filterValue = f.value;
            let filterType = f.type;
            if (f.field === 'uid') {
              filterValue = f.value.toUpperCase();
            }
            if (f.type === '$begins') {
              filterType = '$regex';
              filterValue = `^${f.value}.*`;
            }
            if (f.type === '$ends') {
              filterType = '$regex';
              filterValue = `.*${f.value}$`;
            }
            if (f.type === '$contains') {
              filterType = '$regex';
              filterValue = `.*${f.value}.*`;
            }
            ands.push({ [f.field]: { [filterType]: filterValue } });
          },
        );
    }

    // Build filters payload based on number of conditions
    let filtersPayload;
    if (ands.length === 0) {
      filtersPayload = '';
    } else if (ands.length === 1) {
      filtersPayload = JSON.stringify(ands[0]);
    } else {
      filtersPayload = JSON.stringify({ $and: ands });
    }

    const sortsObj: IKeyValue = values.sorts
 && values.sorts
   .filter((s: ISortItem) => save || (s.active && s.sort !== ''))
 // eslint-disable-next-line
   .reduce((accumulator: any, sortItem: ISortItem) => {
     if (sortItem.sort !== '') {
       return { ...accumulator, ...JSON.parse(sortItem.sort) };
     }
     return { ...accumulator };
   }, {});

    return {
      filters: filtersPayload,
      sorts: Object.keys(sortsObj).length > 0 ? JSON.stringify(sortsObj) : '',
    };
  };

  /* eslint-disable-next-line */
  const onReportFormSubmit = (values: any) => {
    const isEditMode = !showSave;
    if (!isEditMode && hasNotWritePermission && reportId) {
      const userSetFilters = {
        ...values,
        filters: values.filters.filter((f: IFilter) => !f?.server),
        sorts: values.sorts.filter((s: ISortItem) => !s?.server),
      };
      const localPayload = buildReportPayload({ values: userSetFilters, save: isEditMode });
      localStorageService.set('REPORT_FILTERS', {
        reportId,
        filters: localPayload.filters,
        sorts: localPayload.sorts,
      });
    }
    const payload = buildReportPayload({ values, save: isEditMode });
    onSubmitAction(payload.filters, payload.sorts);
  };

  const formik = useFormik({
    initialValues: reportInitialValues,
    validationSchema: buildReportFormValidationSchema(regex),
    enableReinitialize: true,
    onSubmit: onReportFormSubmit,
  });

  const {
    values, dirty, handleSubmit, setFieldValue, errors, touched,
  } = formik;
  /* eslint-disable-next-line */
  // console.log('RENDER INITIAL VALUES', reportInitialValues);
  const auxCls = 'report-filter__wrapper report-execution-filter__last-column report-execution-filter__wrapper';

  /* eslint-disable @typescript-eslint/no-non-null-assertion */
  const onSaveSingleFilter = (type: 'time' | 'filter' | 'sort', indexToSave?: number) => {
    if (!onSaveAction) return;

    const tempValues: IInitialValues & IKeyValue = {
      ...savedValuesRef.current,
      filters: [...(savedValuesRef.current.filters || [])],
      sorts: [...(savedValuesRef.current.sorts || [])],
      displayTimeFilter: savedValuesRef.current.displayTimeFilter,
      timeFilterActive: savedValuesRef.current.timeFilterActive,
      from: savedValuesRef.current.from,
      to: savedValuesRef.current.to,
    };

    if (type === 'time') {
      tempValues.displayTimeFilter = values.displayTimeFilter;
      tempValues.timeFilterActive = values.timeFilterActive;
      tempValues.from = values.from;
      tempValues.to = values.to;
    } else if (type === 'filter' && indexToSave !== undefined && values.filters && values.filters[indexToSave]) {
      const filterToSave = values.filters[indexToSave];

      const existingIndex = tempValues.filters!.findIndex(
        (f: IFilter) => f.field === filterToSave.field,
      );

      if (existingIndex > -1) {
        tempValues.filters![existingIndex] = filterToSave;
      } else {
        tempValues.filters!.push(filterToSave);
      }
    } else if (type === 'sort' && indexToSave !== undefined && values.sorts && values.sorts[indexToSave] !== undefined) {
      const sortToSave: ISortItem = values.sorts[indexToSave];
      if (sortToSave.sort === '') return;
      const existingIndex = tempValues.sorts!
        .findIndex((s: ISortItem) => s.sort === sortToSave.sort);

      if (existingIndex > -1) {
        tempValues.sorts![existingIndex] = sortToSave;
      } else {
        tempValues.sorts!.push(sortToSave);
      }
    }
    const payload = buildReportPayload({ values: tempValues, save: true });
    onSaveAction(payload.filters, payload.sorts);
    savedValuesRef.current = tempValues;
  };

  const onDeleteSingleFilter = (type: 'time' | 'filter' | 'sort', indexToDelete?: number) => {
    if (!onSaveAction) return;

    const tempValues: IInitialValues & IKeyValue = {
      ...savedValuesRef.current,
      filters: [...(savedValuesRef.current.filters || [])],
      sorts: [...(savedValuesRef.current.sorts || [])],
    };

    if (type === 'time') {
      tempValues.displayTimeFilter = false;
      tempValues.timeFilterActive = false;
      tempValues.from = '';
      tempValues.to = '';
    } else if (type === 'filter' && indexToDelete !== undefined) {
      tempValues.filters!.splice(indexToDelete, 1);
    } else if (type === 'sort' && indexToDelete !== undefined) {
      tempValues.sorts!.splice(indexToDelete, 1);
    }

    const payload = buildReportPayload({ values: tempValues, save: true });
    onSaveAction(payload.filters, payload.sorts);
    savedValuesRef.current = tempValues;
  };

  const removeFilterFromView = (index: number) => {
    const newFilters = values.filters?.filter((_, idx) => idx !== index);
    setFieldValue('filters', newFilters);
  };

  const removeSortFromView = (index: number) => {
    const newSorts = values.sorts?.filter((_, idx) => idx !== index);
    setFieldValue('sorts', newSorts);
  };

  const removeTimeFilterFromView = () => {
    setFieldValue('displayTimeFilter', false);
    setFieldValue('from', '');
    setFieldValue('to', '');
    setFieldValue('quickRange', undefined);
  };

  return (
    <>
      <FormikProvider value={formik}>
        <Form style={{ width: '100%' }}>
          {!submitButtonAlwaysEnabled && formik.dirty && !notEditable && <LeavePageModal />}
          <Row>
            <Col span="24">
              <Collapse
                defaultActiveKey={expandedPanels}
                activeKey={expandedPanels}
                bordered={false}
                style={{ backgroundColor: '#fff' }}
                onChange={(keys: string | string[]) => {
                  setExpandedPanels(isArray(keys) ? keys : [keys]);
                }}
              >
                <Panel
                  header="FILTERS"
                  key={FILTERS_PANEL_KEY}
                  style={{ borderBottom: 0 }}
                  forceRender
                  extra={renderFiltersExtraButtons(FILTERS_PANEL_KEY, values, setFieldValue)}
                >
                  {values.displayTimeFilter && (
                    <div className="filter__range form__plain-input--relative">
                      { showRemoveFromView && (
                        <MinusCircleOutlined
                          className={`report-params-minus-icon ${values.timeFilterServer ? 'hidden' : ''}`}
                          onClick={removeTimeFilterFromView}
                        />
                      )}
                      <div className="report-filter__wrapper report-execution-filter__wrapper">
                        { showCheckboxes && (
                          <Checkbox
                            className="filter-checkbox"
                            checked={values.timeFilterActive}
                            onChange={(e) => setFieldValue('timeFilterActive', e.target.checked)}
                            disabled={notEditable || values.timeFilterServer}
                          />
                        ) }
                        <Typography.Text className="report-filter__subtitle">
                          From
                          {(touched.from && errors.from) ? <span className="report-params-error">{errors.from}</span> : ''}
                        </Typography.Text>
                        <DatePicker
                          disabled={notEditable || values.timeFilterServer}
                          name="fromDate"
                          showTime
                          onChange={onDateSelected('from', setFieldValue)}
                          showNow={false}
                          style={(touched.from && errors.from) ? { border: '1px solid red' } : {}}
                        />
                        <Input
                          disabled={notEditable || values.timeFilterServer}
                          name="from"
                          className="report-filter__pseudo-input"
                          onChange={() => {
                            setFieldValue('quickRange', '');
                          }}
                        />
                      </div>
                      <div className="report-filter__wrapper report-execution-filter__wrapper">
                        <Typography.Text className="report-filter__subtitle">
                          To
                          {(touched.to && errors.to) ? <span className="report-params-error">{errors.to}</span> : ''}
                        </Typography.Text>
                        <DatePicker
                          disabled={notEditable || values.timeFilterServer}
                          name="toDate"
                          showTime
                          showNow={false}
                          onChange={onDateSelected('to', setFieldValue)}
                          style={(touched.to && errors.to) ? { border: '1px solid red' } : {}}
                        />
                        <Input
                          disabled={notEditable || values.timeFilterServer}
                          name="to"
                          className="report-filter__pseudo-input"
                          onChange={() => {
                            setFieldValue('quickRange', '');
                          }}
                        />
                      </div>
                      <div className="report-filter__wrapper report-execution-filter__last-column report-execution-filter__wrapper">
                        <Typography.Text className="report-filter__subtitle">
                          Quick ranges
                        </Typography.Text>
                        <Select
                          disabled={notEditable || values.timeFilterServer}
                          name="quickRange"
                          size="large"
                          className="ant__select"
                          style={{ width: '88%', height: 40 }}
                          value={values.quickRange ?? defaultQuickRange}
                          onChange={onQuickRangeSelected(setFieldValue)}
                        >
                          {reportQuickRanges.length
                                && reportQuickRanges.map((item) => (
                                  <Option value={item.value} key={item.value}>
                                    {item.text}
                                  </Option>
                                ))}
                        </Select>
                        { !hasNotWritePermission && (
                          <button
                            disabled={notEditable}
                            type="button"
                            onClick={() => {
                              setDeleteTarget({ type: 'timeFilter' });
                              setDeleteModalVisible(true);
                            }}
                            className="filter__form form__plain-input__delete"
                          >
                            {notEditable ? '' : <ThrashCan />}
                          </button>
                        )}
                        { showSave && !hasNotWritePermission && (
                          <Button
                            disabled={notEditable}
                            type="default"
                            icon={<SaveOutlined />}
                            className="filter__form form__plain-input__save"
                            onClick={() => onSaveSingleFilter('time')}
                          />
                        )}
                      </div>
                    </div>
                  )}
                  <FieldArray name="filters">
                    {(filtersArrayHelpers) => (
                      <FieldArrayRef
                        ref={filtersRef}
                        fieldArrayHelpers={filtersArrayHelpers}
                        values={values}
                        dirty={dirty}
                      >
                        {values.filters && values.filters.length > 0
                        && values.filters.map((filter: IFilter, filterIdx: number) => {
                          // eslint-disable-next-line
                          const fErrors: any = errors.filters || [];
                          // eslint-disable-next-line
                          const fTouched: any = touched.filters || [];
                          const hasFieldError = (
                            fErrors[filterIdx] && !!fErrors[filterIdx].field
                            && fTouched[filterIdx] && !!fTouched[filterIdx].field
                          );
                          const hasTypeError = (
                            fErrors[filterIdx] && !!fErrors[filterIdx].type
                            && fTouched[filterIdx] && !!fTouched[filterIdx].type
                          );
                          const hasValueError = (
                            fErrors[filterIdx] && !!fErrors[filterIdx].value
                            && fTouched[filterIdx] && !!fTouched[filterIdx].value
                          );
                          return (
                            <div
                              className="filter__range form__plain-input--relative"
                              style={{ marginTop: 15 }}
                              // eslint-disable-next-line react/no-array-index-key
                              key={`filter-${filterIdx}`}
                            >
                              { showRemoveFromView && (
                                <MinusCircleOutlined
                                  className={`report-params-minus-icon ${values.filters![filterIdx]?.server ? 'hidden' : ''}`}
                                  onClick={() => removeFilterFromView(filterIdx)}
                                />
                              )}
                              <div
                                className="report-filter__wrapper report-execution-filter__wrapper"
                              >
                                { showCheckboxes && (
                                  <Checkbox
                                    className="filter-checkbox"
                                    checked={filter.active}
                                    onChange={(e) => setFieldValue(`filters.${filterIdx}.active`, e.target.checked)}
                                    disabled={notEditable || values.filters![filterIdx]?.server}
                                  />
                                )}
                                <Typography.Text className="report-filter__subtitle">
                                  Field
                                  {hasFieldError
                                      && (
                                        <span
                                          className="report-params-error"
                                        >
                                          {fErrors[filterIdx].field}
                                        </span>
                                      )}
                                </Typography.Text>
                                <Select
                                  disabled={notEditable
                                    || values.filters![filterIdx]?.server}
                                  name={`filters.${filterIdx}.field`}
                                  size="large"
                                  className={classNames(
                                    'ant__select', { 'invalid-field': hasFieldError },
                                  )}
                                  onChange={async (field) => {
                                    await reportActions.getReportFieldSuggestions(
                                      reportCollection,
                                      field,
                                    );
                                  }}
                                >
                                  {filterFields?.length && (
                                    filterFields.map((field, ffIdx) => (
                                      <Option
                                        // eslint-disable-next-line react/no-array-index-key
                                        key={`${field.value}_${field.text}_${ffIdx}`}
                                        value={field.value}
                                      >
                                        {field.text}
                                      </Option>
                                    ))
                                  )}
                                </Select>
                              </div>
                              <div
                                className="report-filter__wrapper report-execution-filter__wrapper"
                              >
                                <Typography.Text className="report-filter__subtitle">
                                  Type
                                  {hasTypeError
                                    && (
                                      <span className="report-params-error">
                                        {fErrors[filterIdx].type}
                                      </span>
                                    )}
                                </Typography.Text>
                                <Select
                                  disabled={notEditable
                                    || values.filters![filterIdx]?.server}
                                  name={`filters.${filterIdx}.type`}
                                  size="large"
                                  className={classNames(
                                    'ant__select', { 'invalid-field': hasTypeError },
                                  )}
                                >
                                  {operators?.length && (
                                    operators.map((item, oIdx) => (
                                      <Option
                                        value={item.value}
                                        // eslint-disable-next-line react/no-array-index-key
                                        key={`${item.value}_${oIdx}`}
                                      >
                                        {item.text}
                                      </Option>
                                    ))
                                  )}
                                </Select>
                              </div>
                              <div
                                className={auxCls}
                              >
                                <Typography.Text className="report-filter__subtitle">
                                  Value
                                  {hasValueError
                                    && (
                                      <span
                                        className="report-params-error"
                                      >
                                        {fErrors[filterIdx].value}
                                      </span>
                                    )}
                                </Typography.Text>
                                <AutoComplete
                                  disabled={notEditable
                                    || values.filters![filterIdx]?.server}
                                  name={`filters.${filterIdx}.value`}
                                  options={filterSuggestions}
                                  style={{ width: '88%', height: 40 }}
                                  className={classNames(
                                    {
                                      'invalid-field': hasValueError,
                                      'filter-value-autocomplete': true,
                                    },
                                  )}
                                  onChange={(option: string) => {
                                    defineSuggestions(values, filterIdx)(option);
                                  }}
                                  onSearch={
                                    (criteria: string) => (
                                      debouncedSuggestionsSearch(
                                        criteria, filterIdx, values.filters,
                                      )
                                    )
                                  }
                                  onFocus={() => {
                                    // console.log('reportsuggestions', reportFieldSuggestions);
                                    if (values.filters) {
                                      defineSuggestions(values, filterIdx)(
                                        values.filters[filterIdx].value,
                                      );
                                    }
                                  }}
                                />
                                {!hasNotWritePermission && (
                                  <button
                                    disabled={notEditable}
                                    type="button"
                                    onClick={() => {
                                      setDeleteTarget({ type: 'filter', index: filterIdx });
                                      setDeleteModalVisible(true);
                                    }}
                                    className="filter__form form__plain-input__delete"
                                  >
                                    {notEditable ? '' : <ThrashCan /> }
                                  </button>
                                )}
                                { showSave && !hasNotWritePermission && (
                                  <Button
                                    disabled={notEditable}
                                    type="default"
                                    icon={<SaveOutlined />}
                                    className="filter__form form__plain-input__save"
                                    onClick={() => onSaveSingleFilter('filter', filterIdx)}
                                  />
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </FieldArrayRef>
                    )}
                  </FieldArray>
                </Panel>
                <Panel
                  header="SORTING"
                  key={SORTS_PANEL_KEY}
                  style={{ borderBottom: 0 }}
                  className="sort_panel report-params-sort-panel"
                  extra={renderAddSortButton(SORTS_PANEL_KEY)}
                >
                  <FieldArray
                    name="sorts"
                    render={(sortsArrayHelpers: ArrayHelpers) => (
                      (
                        <FieldArrayRef
                          ref={sortsRef}
                          fieldArrayHelpers={sortsArrayHelpers}
                          values={values}
                          dirty={dirty}
                        >
                          {values.sorts && values.sorts.length > 0 && values.sorts.map(
                            (sortItem: ISortItem, sortIdx: number) => (
                              <div
                                // eslint-disable-next-line
                            key={`sort-select-${sortIdx}`}
                                className="report-params-sort-wrapper"
                              >
                                { showRemoveFromView && (
                                  <MinusCircleOutlined
                                    className={`report-params-minus-icon ${values.sorts![sortIdx]?.server ? 'hidden' : ''}`}
                                    onClick={() => removeSortFromView(sortIdx)}
                                  />
                                )}
                                { showCheckboxes && (
                                  <Checkbox
                                    className="filter-checkbox--sort"
                                    checked={sortItem.active}
                                    onChange={(e) => setFieldValue(`sorts.${sortIdx}.active`, e.target.checked)}
                                    disabled={notEditable || values.sorts![sortIdx]?.server}
                                  />
                                ) }
                                <Select
                                  disabled={notEditable || values.sorts![sortIdx]?.server}
                                  name={`sorts.${sortIdx}.sort`}
                                  size="large"
                                  className="ant__select"
                                  style={{ float: 'left', minWidth: '230px', marginLeft: '24px' }}
                                >
                                  {createSortSelectData(
                                    reportColumns || [], sortItem.sort,
                                  ).map((item, optIdx) => (
                                    <Option
                                      value={item.value}
                                      // eslint-disable-next-line
                                        key={`sort-option-${optIdx}`}
                                    >
                                      {item.label}
                                    </Option>
                                  ))}
                                  <Option
                                    value=""
                                    key="sort-option-none"
                                  >
                                    None
                                  </Option>
                                </Select>
                                { !hasNotWritePermission && (
                                  <button
                                    disabled={notEditable}
                                    type="button"
                                    onClick={() => {
                                      setDeleteTarget({ type: 'sort', index: sortIdx });
                                      setDeleteModalVisible(true);
                                    }}
                                    style={{ float: 'left' }}
                                    className="form__plain-input__sort-save"
                                  >
                                    {notEditable ? '' : <ThrashCan /> }
                                  </button>
                                )}
                                { showSave && !hasNotWritePermission && (
                                  <Button
                                    disabled={notEditable}
                                    type="default"
                                    icon={<SaveOutlined />}
                                    className="filter__form form__plain-input__save"
                                    onClick={() => onSaveSingleFilter('sort', sortIdx)}
                                  />
                                )}
                              </div>
                            ),
                          )}
                        </FieldArrayRef>
                      )
                    )}
                  />
                </Panel>
              </Collapse>
            </Col>
          </Row>
          <Row>
            <Col span="24" style={{ paddingTop: 30 }}>
              <div>
                <div>
                  {renderAdditionalButtons && renderAdditionalButtons()}
                  <Button
                    type="primary"
                    className="fields-table__button-next"
                    style={{ width: 280 }}
                    onClick={() => handleSubmit()}
                    disabled={(
                    // (!submitButtonAlwaysEnabled && !dirty && !isValid) || isSubmitting
                      !submitButtonAlwaysEnabled && (!dirty)
                    ) || notEditable}
                  >
                    {submitButtonLabel}
                  </Button>
                </div>
              </div>
            </Col>
          </Row>

        </Form>
      </FormikProvider>
      <DeleteModal
        text={deleteTarget?.type === 'sort' ? 'sorting' : 'filter'}
        modalVisible={deleteModalVisible}
        onCancel={() => {
          setDeleteModalVisible(false);
          setDeleteTarget(null);
        }}
        onConfirm={() => {
          if (deleteTarget) {
            if (deleteTarget.type === 'filter' && typeof deleteTarget.index === 'number') {
              filtersRef.current?.props.fieldArrayHelpers.remove(deleteTarget.index);
              onDeleteSingleFilter('filter', deleteTarget.index);
            } else if (deleteTarget.type === 'sort' && typeof deleteTarget.index === 'number') {
              sortsRef.current?.props.fieldArrayHelpers.remove(deleteTarget.index);
              onDeleteSingleFilter('sort', deleteTarget.index);
            } else if (deleteTarget.type === 'timeFilter') {
              if (values.displayTimeFilter) {
                setFieldValue('displayTimeFilter', false);
                setFieldValue('timeFilterActive', false);
                onDeleteSingleFilter('time');
              }
            }
          }
          setDeleteModalVisible(false);
          setDeleteTarget(null);
        }}
      />
    </>
  );
};

ReportParams.displayName = 'ReportParams';
export default ReportParams;
